import React from 'react';

import styled from '@material-ui/core/styles/styled';

const Proportional = ({ ratio = 56, children, contentWrapperClass = '', ...rest }) => {
  return (
    <Wrapper {...rest}>
      <Ratio ratio={ratio} />
      <Content className={contentWrapperClass}>{children}</Content>
    </Wrapper>
  );
};

export default Proportional;

const Content = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
});
const Ratio = styled('div')(({ ratio }: { ratio: number }) => ({
  width: '100%',
  paddingTop: ratio + '%',
}));
const Wrapper = styled('div')({
  position: 'relative',
  width: '100%',
});
